import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {
  Brands,
  Clients,
  GeneralSettingDto, LoginByQuickAccessDto,
  PasswordLoginDto, QrTokenDto,
  RefreshTokenV3Dto, ResourceProfileOverviewDto,
  SettingType,
  TokenDto
} from "@server-models";


import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {SharedLoginErrorHandlerService} from "@shared/components/login/error-handler/shared-login-error-handler.service";
import {SharedResetPasswordErrorHandlerService} from "@shared/components/login/error-handler/shared-reset-password-error-handler.service";
import {LinkErrorHandlerLoginService} from "@link/services/error-handler-login/link-error-handler-login.service";

@Injectable({
  providedIn: 'root'
})
export class SharedLoginApiService extends CoreHttpClientApiBaseService {

  login(email: string, passwordBase64?: string): Observable<TokenDto> {
    const body: PasswordLoginDto = {
      email,
      passwordBase64
    }

    const options = {
      errorHandler: new SharedLoginErrorHandlerService(this._store, this._alertControllerService, this._translateService, this._router)
    }

    return super.post<TokenDto>(`/identity/login/password`, false, body, options);
  }

  loginByQuickAccessKey(key: string): Observable<QrTokenDto> {
    const body: LoginByQuickAccessDto = {
      key: key
    }

    const options = {
      errorHandler: new LinkErrorHandlerLoginService(this._store, this._alertControllerService, this._translateService, this._router)
    }

    return super.post<QrTokenDto>(`/identity/login/LoginQuickAccess`, false, body, options);
  }

  getQuickAccessProfile(resourceId: number): Observable<ResourceProfileOverviewDto> {
    return super.get<ResourceProfileOverviewDto>(`/tech/resource/${ resourceId }/profile`);
  }

  changePassword(email: string, oldPasswordBase64: string, newPasswordBase64: string): Observable<any> {
    const body = {
      email,
      passwordBase64: oldPasswordBase64,
      newPasswordBase64
    }
    return super.post<any>(`/identity/login/changepassword`, false, body);
  }

  requestPasswordReset(email: string, brand: Brands): Observable<void> {
    const body = {
      email,
      brand
    }
    const options = {
      errorHandler: new SharedResetPasswordErrorHandlerService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.post<void>(`/identity/login/requestPasswordReset`, false, body, options);
  }

  refreshToken(refreshToken: string, tenantId: number, client?: Clients): Observable<TokenDto> {
    const body: RefreshTokenV3Dto = {
      refreshToken,
      tenantId,
      client
    }
    const options = {
      errorHandler: new SharedLoginErrorHandlerService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.post<TokenDto>(`/identity/v3/login/refresh`, false, body, options);
  }

  getAppSettings(tenantId: number): Observable<GeneralSettingDto> {
    // SettingType.General is hardcoded
    return super.get(`/orga/tenant/${ tenantId }/setting/${ SettingType.General }`, undefined);
  }

}
